export const ImageUsage = {
  COVER: "cover",
  GALLERY: "gallery",
} as const;

/**
 * IMAGE_USAGE_OPTIONS is a list of options for the image usage.
 * It is used to determine the usage of the image.
 */
export const IMAGE_USAGE_OPTIONS = [
  { value: "cover", label: "Cover Image" },
  { value: "gallery", label: "Gallery Image" },
] as const;

export function getCoverImage<T extends { usage?: string }>(images: T[]) {
  return images.find((image) => image.usage === "cover") as T | undefined;
}
